@if (componentData$ | async; as carousel) {
    @if (tabs$ | async; as tabs) {
        @if (tabs.length > 0) {
            <div class="aimo-background" [class]="getBgClass(carousel)"></div>
            <div class="container">
                <div class="aimo-tab-wrapper">
                    <div class="aimo-tab-border">
                        <div class="tab-items tab-items-lg d-flex align-items-center">
                            @for (tab of tabs; track tab.uid; let idx = $index) {
                                <div
                                    id="tab_{{ idx }}"
                                    (click)="setActiveTab(tab, $event)"
                                    class="tab-item tab-item-auto-width tab-item-border-transparent cursor-pointer"
                                    [ngClass]="{ active: isActiveTab(tab, idx) }">
                                    @if (tab.tabIcon) {
                                        <i
                                            class="aimo-icon icon-inline icon-petrol-blue mr-1"
                                            [ngClass]="{
                                                'icon-star': tab.tabIcon === 'ICON_STAR',
                                                'icon-chart-bar': tab.tabIcon === 'ICON_CHART_BAR',
                                                'icon-tag': tab.tabIcon === 'ICON_TAG',
                                                'icon-sparkle': tab.tabIcon === 'ICON_SPARKLE',
                                                'icon-leaf': tab.tabIcon === 'ICON_LEAF',
                                                'icon-target': tab.tabIcon === 'ICON_TARGET',
                                                'icon-shooting-star': tab.tabIcon === 'ICON_SHOOTING_STAR',
                                            }"></i>
                                    }
                                    {{ tab.title }}
                                </div>
                            }
                            @if (showAsAccordion) {
                                <div class="d-flex align-items-center ml-auto">
                                    <button
                                        class="btn btn-sm btn-icon btn-icon-transparent ml-4"
                                        (click)="toggleAccordion()">
                                        <i
                                            class="aimo-icon icon-lg icon-petrol-blue"
                                            [ngClass]="{
                                                'icon-caret-down': !accordionOpen,
                                                'icon-caret-up': accordionOpen,
                                            }"></i>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                @if (accordionOpen) {
                    @for (tab of tabs; track tab.uid; let idx = $index) {
                        <div class="tab-content">
                            @if (isActiveTab(tab, idx)) {
                                <aimo-cms-carousel
                                    [data$]="getProductCarouselData(tab)"
                                    [showAsAccordion]="false"></aimo-cms-carousel>
                            }
                        </div>
                    }
                }
            </div>
        }
    } @else {
        <aimo-spinner></aimo-spinner>
    }
}
